

export const LocationTypes = {
    GET_ACTIVE_LOCATIONS : 'GET_ACTIVE_LOCATIONS',
    CLEAR_ACTIVE_LOCATIONS : 'CLEAR_ACTIVE_LOCATIONS',
}